
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Categories 
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestDocCategories = credentials => {
  return {
    type: 'REQUEST_DOC_CATEGORIES'
  }
}

export const receiveDocCategoriesSuccess = data => ({
  type: 'RECEIVE_DOC_CATEGORIES_SUCCESS',
  data
})

export const receiveDocCategoriesFail = data => ({
  type: 'RECEIVE_DOC_CATEGORIES_FAIL',
  data
})

export const tryToFetchDocCategories = packet => dispatch => {
  dispatch(requestDocCategories());
  
  return fetch('/api/docs/categories', {
    method: 'get',
    headers: {
      "Content-Type": "application/json"
    }
  })
  .then((response) => {
    let json = response.json();
    if (response.status >= 200 && response.status < 300) return json;
    return json.then(Promise.reject.bind(Promise));
  })
  .then(function(json){
    return dispatch(receiveDocCategoriesSuccess(json));
  })
  .catch(e => {
    dispatch(receiveDocCategoriesFail({errors:e}));
  })
}


// WEBPACK FOOTER //
// ./src/actions/docs/a.d.GET.categories.js